'use strict';
/**
 * @typedef {import('./types').EncoderOptions} EncoderOptions
 * @typedef {import('./types').DecoderOptions} DecoderOptions
 */

exports.encode = require('./encode');
exports.decode = require('./decode');
exports.varintEncode = require('./varint-encode');
exports.varintDecode = require('./varint-decode');
exports.int32BEEncode = require('./int32BE-encode');
exports.int32BEDecode = require('./int32BE-decode');